import React from 'react';
export default function MutedText({ children }) {
    return (
        <p className="mt-0 text-muted">{children}</p>
    );
}
